<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-icon small v-on="on">mdi-lead-pencil</v-icon>
				</template>
				<span>edit spot</span>
			</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6">
				<span class="subtitle-2">New parameters of the spot <span class="accentColor">{{ spot.name }}</span>
				</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="8" md="6">
							<v-select dense
								:items="adFeatures()"
								item-text="text"
								item-color="#1A237E"
								color="#1A237E"
								v-model="advanced"
								label="advanced feature"
								@change="onceMore()"
							></v-select>
						</v-col>
						<v-col cols="12" sm="8" md="6">
							<v-select dense
								:items="values"
								item-text="text"
								item-value="value"
								color="#1A237E"
								item-color="#1A237E"
								v-model="value"
								label="value"
								@change="onceMore()"
							></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense
								:items="features"
								color="#1A237E"
								item-color="#1A237E"
								v-model="feature"
								label="core feature"
								@change="onceMore()"
							></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense
								:items="prices"
								color="#1A237E"
								item-color="#1A237E"
								v-model="price"
								label="price"
								@change="onceMore()"
							></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense
								:items="channelsNumbers"
								color="#1A237E"
								v-model.number="channels"
								item-color="#1A237E"
								label="channels"
								:rules="requiredRules"
								@change="onceMore()"
							></v-select>
						</v-col>
						<v-col v-if="spot.type==1" cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="trademark"
								v-model="trademark"
								name="trademark"
								type="text"
								readonly>
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error mx-2">{{error}}</v-row>
				<v-row justify="center" class="text-no-wrap mx-2">{{message}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Decline
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:loading="loading" 
					:disabled="!valid || loading || calculating"
					@click="calculate"
				>Calculate</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="!calculating || Boolean(error)"
					@click="updateSpot"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-xs-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import numeral from 'numeral'
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['spot', 'gameId', 'round'],
		data () {
			return	{
				dialog: false,
				valid: false,
				message: '',
				error: '',
				calculating: false,
				requiredRules: [v => !!v || 'this field is required'],
				features: ['none', 'material', 'manufacturing', 'design'],
				prices: ['none','low', 'reasonable','high', 'very high'],
				values: [{text: 'none', value: ''}, 
					{text: 'family / kids', value: 'family'},
					{text: 'strong personality', value: 'strongPerson'},
					{text: 'personal attractiveness', value: 'attractiveness'},
					{text: 'pets', value: 'pets'},
					{text: 'social status',value: 'socStatus'},
					{text: 'friendship', value: 'friendship'},
					{text: 'fun', value: 'fun'}],
				channelsNumbers: [1, 2, 3, 4, 5],
				feature: this.spot.coreFeature,
				advanced: this.spot.advancedFeature,
				value: this.spot.value,
				price: this.spot.price,
				channels: this.spot.channels,
				investments: 0
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			trademarks () {
				return this.$store.getters.trademarks
			}, 
			advancedFeatures () {
				return this.$store.getters.advancedFeatures
			},
			trademark () {
				const br = this.trademarks.find(br => br.name == this.spot.trademark)
				if (br) return br.name
				return ''
			}
		},
		methods: {
			
			adFeatures () {
				const arr=['none']
				return (arr.concat(this.advancedFeatures))
			},
			onceMore () {
				this.error = ''
				this.message = ''			
				this.calculating = false	
			},
			calculate () {
				
				if (this.$refs.form.validate()) {
					//					
					if (this.feature === this.spot.coreFeature && 
						this.advanced === this.spot.advancedFeature &&
						this.price === this.spot.price &&
						this.value === this.spot.value &&
						this.channels === this.spot.channels) {

						this.error = 'You did\'n change any param of the spot'	
					}
					else {
						this.error = ''	
						//investments
						if (this.feature && this.feature !== 'none' && this.feature !== this.spot.coreFeature) {
							this.investments+= 100
						}
						if (this.advanced && this.advanced !== 'none' && this.advanced !== this.spot.advancedFeature) {
							this.investments+= 120
						}
						if (this.price && this.price !== 'none' && this.price !== this.spot.price) {
							this.investments+= 60
						}
						if (this.value && this.value !== 'none' && this.value !== this.spot.value) {
							this.investments+= 150
						}
						if (this.channels !== this.spot.channels) {
							const oldLevel = ((this.spot.channels + 1) / 2)
							const newLevel = ((this.channels + 1) / 2)

							if (this.investments == 0){
								this.investments = 1 * Math.abs(newLevel - oldLevel)
							} else {
								this.investments *= Math.abs(newLevel - oldLevel)
							} 
						}
						this.message = `You will invest $${numeral(this.investments).format('0,0[.]0')} to update the spot`
						this.calculating = true	
					}
				}
			},
			async updateSpot () {

				//new params of spot
					this.spot.coreFeature = this.feature
					this.spot.advancedFeature = this.advanced
					this.spot.price = this.price
					this.spot.value = this.value
					this.spot.channels = this.channels
					this.spot.investments = (this.investments + this.spot.investments)

				try {
					//change spot 
					await this.$store.dispatch('changeSpot', {
						gameId: this.gameId,
						round: this.round,
						spot: this.spot
					})
					this.closeDialog ()					
				}
				catch (error) {
					throw error
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.calculating = false
				this.message = ''
				this.error = ''
				this.investments = 0
			}
		},
		components: {Loader}
	}
</script>
